{
  "Breadcrumbs": {
    "podcasts": "Podcasts"
  },
  "Tenants": {
    "Provisioning": {
      "NewTenant": "New Pool Tenant",
      "Title": "Create Pool Tenant",
      "Subdomain": "Subdomain",
      "SubdomainPlaceholder": "e.g. acme",
      "SubdomainHint": "3-31 chars, lowercase letter then alphanumeric/hyphens. Input is normalized automatically (umlauts, spaces, pasted URLs)",
      "DisplayName": "Display Name",
      "ContactEmail": "Customer administrator email",
      "ContactEmailHint": "Receives the Company Administrator invite. Simon is added as platform administrator; Simon and Max receive provisioning notifications.",
      "ContactFirstname": "First Name (optional)",
      "ContactLastname": "Last Name (optional)",
      "ContactPhone": "Phone (optional)",
      "Trial": "Trial (14 days)",
      "TrialHint": "Trial tenants become read-only after 14 days and are deleted after 35 days unless they are activated in the tenant list.",
      "SampleContent": "Add sample podcast (Podcast Mastery)",
      "SampleContentHint": "Seeds the sample podcast with its episodes into the new tenant, so it does not start empty.",
      "FeatureFlags.Title": "Advanced settings",
      "FeatureFlags.Description": "Feature flags inherit their global defaults. Changes made here are stored only as tenant-specific overrides.",
      "FeatureFlags.SelectedCount": "{{selected}} of {{total}} enabled",
      "FeatureFlags.Loading": "Loading feature flags…",
      "FeatureFlags.Empty": "No feature flags are available. The tenant will inherit the global configuration.",
      "FeatureFlags.LoadFailed": "Feature flags could not be loaded. Global defaults will be inherited.",
      "FeatureFlags.DefaultOn": "Default on",
      "FeatureFlags.DefaultOff": "Default off",
      "Submit": "Provision Tenant",
      "Cancel": "Cancel",
      "Validation.Required": "Required",
      "Validation.SubdomainPattern": "Invalid format",
      "Validation.EmailInvalid": "Invalid email",
      "Status.Title": "Status",
      "Status.AdminUrl": "Admin URL:",
      "Status.CurrentStep": "Current step:",
      "Status.StepPosition": "(step {{position}} of {{total}})",
      "Status.RunStatus": "Status:",
      "Status.LastError": "Last error:",
      "Step.Pending": "Pending",
      "Step.ValidatingInput": "Validating input",
      "Step.CreatingDatabase": "Creating database",
      "Step.CreatingDnsRecords": "Creating DNS records",
      "Step.CommittingInfraChanges": "Committing infra changes",
      "Step.WaitingForArgoSync": "Waiting for ArgoCD sync",
      "Step.RestartingTenantApiPods": "Restarting tenant API pods",
      "Step.WaitingForCertReady": "Waiting for TLS certificate",
      "Step.EnsuringGcpCertMapping": "Provisioning load-balancer TLS",
      "Step.CreatingAuthClients": "Creating auth clients",
      "Step.RunningTenantSetup": "Initializing tenant data",
      "Step.SeedingSampleContent": "Adding sample content",
      "Step.CreatingTenantRecord": "Creating tenant record",
      "Step.FetchingCompanyLogo": "Looking up company logo",
      "Step.Completed": "Completed",
      "Toast.SuccessProvisioned": "Tenant {{subdomain}} provisioned.",
      "Toast.SuccessReady": "Tenant {{subdomain}} ready.",
      "Toast.ProvisioningFailed": "Provisioning failed: {{error}}",
      "Toast.StatusPollingFailed": "Status polling failed: {{error}}",
      "Toast.GenericError": "Provisioning failed.",
      "Retry": "Retry failed run",
      "Deprovision": "Deprovision",
      "DeprovisionKeepDb": "Deprovision (keep database)",
      "DeprovisionDropDb": "Deprovision + drop database",
      "Success.Title": "Tenant provisioned successfully",
      "Success.OpenAdmin": "Open admin",
      "Success.GoToList": "Go to tenant list",
      "Success.ProvisionAnother": "Provision another tenant",
      "Toast.RetryStarted": "Retry of {{subdomain}} started.",
      "Toast.RetryFailed": "Retry failed: {{error}}",
      "Toast.Deprovisioned": "Tenant {{subdomain}} deprovisioned.",
      "Toast.DeprovisionFailed": "Deprovision failed: {{error}}",
      "Toast.DeprovisionStarted": "Deprovisioning of {{subdomain}} started. This takes a few minutes.",
      "Toast.DeprovisionPartial": "Deprovisioning of {{subdomain}} finished with errors: {{error}}. You can trigger it again.",
      "Toast.DeprovisionTimeout": "Deprovisioning of {{subdomain}} is still not finished. Status unknown, check again later.",
      "Toast.DeprovisionPollingFailed": "Status of the deprovisioning of {{subdomain}} could not be read ({{error}}). Check again later.",
      "Dialog.DeprovisionKeepDb.Title": "Deprovision tenant",
      "Dialog.DeprovisionKeepDb.Text": "This removes <strong>{{subdomain}}</strong> from the cluster: DNS records, certificates, gateway routes, and per-tenant secrets. The tenant database is <strong>kept</strong>. The operation is irreversible at the cluster level.",
      "Dialog.DeprovisionDropDb.Title": "Deprovision tenant + drop database",
      "Dialog.DeprovisionDropDb.Text": "This removes <strong>{{subdomain}}</strong> from the cluster AND drops the tenant database (<strong>{{subdomain}}_db</strong>). All podcasts, recordings and users are permanently lost. To confirm, type the subdomain below.",
      "Dialog.DeprovisionConfirm.Label": "Type the subdomain to confirm",
      "Dialog.Cancel": "Cancel",
      "Dialog.Confirm": "Confirm"
    },
    "List": {
      "Created": "Created"
    },
    "Tabs": {
      "Trial": "Trial & Onboarding",
      "Plan": "Plan",
      "FeatureFlags": "Feature flags"
    },
    "Plan": {
      "Title": "Plan",
      "Loading": "Loading plan",
      "Retry": "Try again",
      "EffectivePlan": "Effective plan",
      "SourceLabel": "Source",
      "StripePlan": "Stripe plan",
      "NoStripePlan": "No Stripe plan",
      "WithPrivateRss": "(+ Private RSS)",
      "NoPlan": "No plan, no limits",
      "NoPlanHint": "This tenant has no plan, so no limits apply. Existing customers are never limited.",
      "UsageTitle": "Limits and usage",
      "UsageUnavailable": "The usage could not be read from the tenant API.",
      "OverLimit": "Over limit",
      "Name": {
        "unlimited": "Unlimited",
        "small": "Small",
        "medium": "Medium",
        "large": "Large"
      },
      "Source": {
        "Stripe": "Stripe plan",
        "Override": "Operator override",
        "None": "No plan, no limits"
      },
      "Mode": {
        "Enforced": "Enforced",
        "ReportOnly": "Report only",
        "EnforcedHint": "The tenant API blocks new podcasts and creator seats above the limits.",
        "ReportOnlyHint": "The tenant API only reports when a limit is exceeded and blocks nothing."
      },
      "Resource": {
        "podcasts": "Podcasts",
        "creatorSeats": "Creator seats",
        "employees": "Employees"
      },
      "Usage": {
        "OfLimit": "{{used}} of {{limit}}",
        "NoLimit": "{{used}} (no limit)",
        "Unknown": "-"
      },
      "Override": {
        "Title": "Operator override",
        "Description": "An override replaces the plan from Stripe for the limits. Billing in Stripe stays unchanged.",
        "Label": "Plan",
        "Hint": "Follow Stripe removes the override.",
        "Follow": "Follow Stripe",
        "Save": "Save plan",
        "Discard": "Discard"
      },
      "Confirm": {
        "Title": "Change the plan of {{subdomain}}",
        "TextOverride": "Set the plan of <strong>{{subdomain}}</strong> to <strong>{{plan}}</strong>? The limits of this plan apply right away, regardless of the plan in Stripe.",
        "TextFollow": "Remove the override of <strong>{{subdomain}}</strong>? The limits follow the plan in Stripe again. Without a Stripe plan the tenant is not limited.",
        "Save": "Save plan"
      },
      "Toast": {
        "Saved": "Plan of {{subdomain}} saved."
      },
      "Error": {
        "NoTenant": "No tenant was selected.",
        "NotFound": "No tenant with the subdomain {{subdomain}} exists.",
        "Invalid": "The plan was rejected: {{detail}}",
        "Failed": "The plan could not be loaded or saved: {{detail}}"
      },
      "Features": {
        "Title": "Features",
        "Feature": "Feature",
        "InPlan": "In plan",
        "Active": "Active",
        "Status": "Status",
        "Yes": "Yes",
        "No": "No",
        "Unknown": "Unknown",
        "State": {
          "Pending": "Being applied",
          "PendingHint": "The plan includes this feature. The master turns it on automatically.",
          "NotInPlan": "Not in plan",
          "NotInPlanHint": "Will not be turned off automatically. Change it in Feature flags if needed."
        },
        "Summary": {
          "AllMatch": "All features match the plan.",
          "NotInPlanOne": "1 feature is on but not in the plan.",
          "NotInPlanOther": "{{count}} features are on but not in the plan.",
          "PendingOne": "1 feature of the plan is being applied.",
          "PendingOther": "{{count}} features of the plan are being applied.",
          "UnknownOne": "The state of 1 feature could not be read.",
          "UnknownOther": "The state of {{count}} features could not be read."
        },
        "NotInPlanHint": "The master turns on what the plan includes but never turns anything off. Change these features in Feature flags if needed.",
        "OpenFeatureFlags": "Open feature flags",
        "AppliedFor": "Features last applied for plan:",
        "NotAppliedYet": "not applied yet",
        "NoPlan": "No plan, features are managed by hand.",
        "PrivateRssNote": "Private RSS on Spotify/Apple: set up with Supporting Cast (manual)."
      }
    },
    "PlanUsage": {
      "Title": "Plan usage",
      "Breadcrumb": "Tenants",
      "Description": "Tenants with a plan, compared with their limits. Tenants over a limit come first.",
      "Loading": "Loading plan usage",
      "Summary": "{{total}} tenants with a plan, {{over}} over a limit",
      "OnlyOverLimit": "Only over limit",
      "Empty": "No tenant has a plan yet.",
      "EmptyOver": "No tenant is over a limit.",
      "Column": {
        "Tenant": "Tenant",
        "Plan": "Plan",
        "Mode": "Mode"
      }
    }
  },
  "Login": {
    "Email confirmation text": "Thank you for confirming your email address. Please login to continue.",
    "Login title": "Login",
    "Login": "Login",
    "Password": "Password",
    "Email": "Email",
    "The email address is required": "The email address is required",
    "The email address is not valid": "The email address is not valid",
    "The email address or password do not exist": "The email address or password do not exist",
    "This account has been blocked": "This account has been blocked",
    "An unknown error has occured": "An unknown error has occured",
    "Your organization is currently deactivated": "Your organization is currently deactivated",
    "Please confirm your email address": "Please confirm your email address",
    "Your password is required": "Your password is required",
    "Forgot password?": "Forgot password?",
    "Imprint": "Imprint",
    "Data protection": "Data protection",
    "Teaser headline": "HYPECAST<br> Your All-in-One Corporate Podcasting Solution",
    "Teaser subline": "Create and distribute your internal and external corporate podcasts - easy and safe! Manage your audio content, premium content, and subscribers in one tool. Create individual audiences and personalized, curated playlist for your audiences."
  }
}
